 var omc_s0 = document.createElement("script");
 omc_s0.type = "text/javascript";
 omc_s0.src = "https://cdn.jsdelivr.net/npm/js-md5@0.7.3/build/md5.min.js";
 document.head.appendChild(omc_s0);
      
 var omc_s1 = document.createElement("script");
 omc_s1.type = "text/javascript";
 omc_s1.src = "https://chat.omnicommerce.app/webrocket.js";
 omc_s1.onload = () => {
   omc.init({
     publicKey: '148f7a4308', // Solicitar a soporte webrocket publicKey
     webchat: {
       publicKey: '87390b957a', // Solicitar a soporte webchat publicKey
     }, 
     callback : () => {  } // function: Se ejecutará tras iniciar Webrocket
   })
 }
 document.head.appendChild(omc_s1);